var map = {
	"./arrow-back.svg": 1282,
	"./arrow-down.svg": 1228,
	"./arrow-up.svg": 5327,
	"./broadcasting.svg": 8092,
	"./catalog-monitoring.svg": 3122,
	"./catalog.svg": 616,
	"./close.svg": 3833,
	"./confirmed-by-lenta.svg": 3053,
	"./contractor-section.svg": 2297,
	"./delete.svg": 827,
	"./draggable.svg": 5109,
	"./edit.svg": 1311,
	"./group.svg": 8907,
	"./lenta-logo.svg": 7079,
	"./lenta-text.svg": 4956,
	"./logout.svg": 7177,
	"./notification.svg": 3839,
	"./plus.svg": 5097,
	"./price-change.svg": 2072,
	"./price-tag.svg": 2549,
	"./price-text.svg": 6595,
	"./report.svg": 9051,
	"./reset-search.svg": 8353,
	"./result-monitoring.svg": 5621,
	"./search.svg": 5474,
	"./setting.svg": 7207,
	"./sidebar-close.svg": 3644,
	"./sidebar-open.svg": 2470,
	"./start-monitoring.svg": 8070,
	"./transfer-results.svg": 7892,
	"./warning-yellow.svg": 3693,
	"./weight.svg": 659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;